import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import { ChangeEvent } from "react";
import InputMask from 'react-input-mask';
import Select from "./Select";
import { Field } from "../Types/Form";
import { addLocale } from 'primereact/api';
import { Calendar } from 'primereact/calendar';

type props = {
    field: Field;
    value?: any;
    error?: string;
    disabled?: boolean;
    onChange?: (name: string, value: any) => any;
    onCancel?: (arg: any) => any
}

/*const calendarLocale = {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить'
}

addLocale('ru', calendarLocale); */

const phoneFieldNames = ["phone", "phon", "number", "phonenumber", "usernumber", "userphone"];

const Input = React.memo(({ field, value, error, onChange, disabled, onCancel }: props) => {

    const [localeValue, setLocaleValue] = useState(value);
    const { name, title, element, link, ref, editable} = field;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const inputValueRef = useRef(localeValue);

    useEffect(() => {
        if (disabled || editable) setIsDisabled(true);
    }, [])

    useEffect(() => {
        setLocaleValue(value);
    }, [value])

    if (ref) {
        useImperativeHandle(ref, () => ({
            getData() {
                return localeValue;
            }
        }));
    }

    const handleChange = (elValue, el?) => {
        console.log("elValue", elValue, "el", el);
        if (el && el === "calendar") {
            if (typeof elValue === "string") {
                const parts = elValue.split(".");
                if (parts.length === 3) {
                    const [day, month, year] = parts.map(Number);
                    // Создаём дату в локальном времени
                    const parsedDate = new Date(year, month - 1, day);
                    parsedDate.setMinutes(parsedDate.getMinutes() - parsedDate.getTimezoneOffset());
                    inputValueRef.current = parsedDate;
                    setLocaleValue(parsedDate);
                }
            } else if (elValue instanceof Date) {
                // Для объекта Date также корректируем временную зону
                const adjustedDate = new Date(elValue);
                adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset());
                inputValueRef.current = adjustedDate;
                setLocaleValue(adjustedDate);
            }
        } else {
            inputValueRef.current = elValue;
            setLocaleValue(elValue);
        }
    }

    const sendValue = (elValue) => {
        if (onChange) onChange(name, elValue);
    }

    const rand = Math.random();

    if (field.element === "radio") return (
        <div className={`inputWrapper ${isDisabled && "disabledInput"}`}>
            <label className={error ? `checkbox error` : `checkbox`} htmlFor={name + rand}>
                <input
                    type="radio"
                    id={name + rand}
                    name={name}
                    checked={localeValue}
                    onChange={(e) => sendValue(e.target.checked)}
                />
                <p>{title} {link && <a href={link.url}>{link.linkName}</a>}</p>
            </label>
        </div>
    )

    if (phoneFieldNames.some(item => name.toLowerCase().trim().includes(item))) return (
        <div className={`inputWrapper ${field.isLight && "light"} ${isDisabled && "disabledInput"}`}>
            {title && <span>{title}</span>}

            {editable &&
                <div className="editableActions">
                    {isDisabled ? (
                        <button onClick={() => {
                            setIsDisabled(false);
                            sendValue(localeValue)
                        }}
                        >Изменить</button>
                    ) : (
                        <>
                            <button onClick={() => {
                                setIsDisabled(true);
                            }}>Сохранить</button>
                            <button onClick={() => {
                                onCancel(name);
                                setIsDisabled(true);
                            }}>Отмена</button>
                        </>
                    )}
                </div>
            }

            <InputMask
                name={name}
                mask="+7 (999) 999-99-99"
                placeholder="+7 (___) ___-__-__"
                value={localeValue}
                onChange={(e) => handleChange(e.target.value)}
                onBlur={() => sendValue(localeValue)}
            />
            {error && <p className="error">{error}</p>}
        </div>
    )


    if (element === "checkbox") return (
        <div className={`inputWrapper ${isDisabled && "disabledInput"}`}>
            <label className={error ? `checkbox ${field.isLight && "light"} error` : `${field.isLight && "light"} checkbox`} htmlFor={name}>
                <input
                    type="checkbox"
                    id={name}
                    name={name}
                    onChange={(e) => sendValue(e.target.checked)}
                    checked={value}
                />
                {field?.body ? (
                    field?.body()
                ): (
                   <p>{title} {link && <a href={link.url}>{link.linkName}</a>}</p>
                )}
            </label>
        </div>
    )

    if (element === "textarea") return (
        <div className={`inputWrapper ${field.isLight && "light"} ${isDisabled && "disabledInput"}`}>
            {title && <span>{title}</span>}

            {editable &&
                <div className="editableActions">
                    {isDisabled ? (
                        <button onClick={() => {
                            setIsDisabled(false);
                            sendValue(localeValue)
                        }}
                        >Изменить</button>
                    ) : (
                        <>
                            <button onClick={() => {
                                setIsDisabled(true);
                            }}>Сохранить</button>
                            <button onClick={() => {
                                onCancel(name);
                                setIsDisabled(true);
                            }}>Отмена</button>
                        </>
                    )}
                </div>
            }

            <textarea
                name={name}
                value={localeValue}
                onChange={(e) => handleChange(e.target.value)}
                onBlur={() => sendValue(localeValue)}
            />
            {error && <p className="error">{error}</p>}
        </div>
    )

    if (element === "select") return (
        <div className={`inputWrapper ${isDisabled && "disabledInput"}`}>
            {title && <span>{title}</span>}

            {editable &&
                <div className="editableActions">
                    {isDisabled ? (
                        <button onClick={() => {
                            setIsDisabled(false);
                            sendValue(localeValue)
                        }}
                        >Изменить</button>
                    ) : (
                        <>
                            <button onClick={() => {
                                setIsDisabled(true);
                            }}>Сохранить</button>
                            <button onClick={() => {
                                onCancel(name);
                                setIsDisabled(true);
                            }}>Отмена</button>
                        </>
                    )}
                </div>
            }

            <Select
                field={field}
                onChange={onChange}
                localeValue={localeValue}
            />
            {error && <p className="error">{error}</p>}
        </div>
    )

    if (element === "calendar") return (

        <div className={`inputWrapper ${isDisabled && "disabledInput"}`}>
            {title && <span>{title}</span>}

            {editable && 
                <div className="editableActions">
                    {isDisabled ? (
                        <button onClick={() => {
                            setIsDisabled(false);
                            sendValue(localeValue);
                        }}
                        >Изменить</button>
                    ) : (
                        <>
                            <button onClick={() => {
                                setIsDisabled(true);
                            }}>Сохранить</button>
                            <button onClick={() => {
                                onCancel(name);
                                setIsDisabled(true);
                            }}>Отмена</button>
                        </>
                    )}
                </div>    
            }

            <Calendar
                value={localeValue ? new Date(localeValue) : null}
                onChange={(e) => handleChange(e.value, "calendar")}
                onInput={(e) => handleChange(e.target.value, "calendar")}
                onFocus={() => setIsFocused(true)}
                onBlur={() => sendValue(inputValueRef.current)}
                showIcon
                hourFormat="24"
                locale="ru"
                placeholder="Введите дату или выберите"
                dateFormat="dd.mm.yy"
            />
            {error && <p className="error">{error}</p>}
        </div>
    )


    return (
        <div className={`inputWrapper ${field.isLight && "light"} ${isDisabled && "disabledInput"}`}>
            {title && <span>{title}</span>}

            {editable && 
                <div className="editableActions">
                    {isDisabled ? (
                        <button onClick={() => {
                            setIsDisabled(false);
                            sendValue(localeValue)
                        }}
                        >Изменить</button>
                    ) : (
                        <>
                            <button onClick={() => {
                                setIsDisabled(true);
                            }}>Сохранить</button>
                            <button onClick={() => {
                                onCancel(name);
                                setIsDisabled(true);
                            }}>Отмена</button>
                        </>
                    )}
                </div>    
            }

            <input
                name={name}
                value={localeValue}
                placeholder={!localeValue && "Не заполнено"}
                onChange={(e) => handleChange(e.target.value)}
                onBlur={() => sendValue(localeValue)}
            />
            {error && <p className="error">{error}</p>}
        </div>
    )
})

export default Input;